import home from './src/home.vue'
import TourReportManagerInfo from './src/TourReportManager/TourReportManagerInfo.vue' 
import TourReportManagerView from './src/TourReportManager/TourReportManagerView.vue' 
import TourReportView from './src/TourReportManager/TourReportView.vue' 

let views = {
    home,
    TourReportManagerInfo,
    TourReportManagerView,
    TourReportView
};

export default views;